
/* 리커트 5단계 표정 아이콘 — 점수값(1~5) 기준. 보기 셔플과 무관하게 정확히 매칭 */
(function(){
  var W='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">';
  var F={
    1: W+'<circle cx="12" cy="12" r="9"/><path d="M8 16.5q4-4 8 0"/><path d="m8.5 9 2 1.6M15.5 9l-2 1.6"/></svg>',
    2: W+'<circle cx="12" cy="12" r="9"/><path d="M8.8 16q3.2-2 6.4 0"/><path d="M9 9.6h.01M15 9.6h.01"/></svg>',
    3: W+'<circle cx="12" cy="12" r="9"/><path d="M8.5 15.5h7"/><path d="M9 9.6h.01M15 9.6h.01"/></svg>',
    4: W+'<circle cx="12" cy="12" r="9"/><path d="M8.5 14.5q3.5 3 7 0"/><path d="M9 9.6h.01M15 9.6h.01"/></svg>',
    5: W+'<circle cx="12" cy="12" r="9"/><path d="M8 14q4 4 8 0"/><path d="m7.4 8.6 1.2 1.2 1.2-1.2M14.2 8.6l1.2 1.2 1.2-1.2"/></svg>'
  };
  window.PIA_FACE=function(v){
    var h=F[v]; if(!h) return '';
    return '<span class="pia-choice__face" aria-hidden="true">'+h+'</span>';
  };
})();
